import 'utility-ng-interface';
import 'ui-ng-progress';

angular.module('biz-ng-career-details', ['utility-ng-interface', 'ui-ng-progress']);

import './core.ts';

export default 'biz-ng-career-details';



// WEBPACK FOOTER //
// ./app/vendor/biz-ng-career-details/src/main.ts